import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { MarketplaceCampaignPostStatusForSearch, MarketplaceDetail } from '@anytag/graphql';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { Form } from '@anytag/shared-atoms';
import { Option } from '@anytag/shared-types';
import { DownloadMarketplacePostsButton } from './DownloadMarketplacePostsButton';
import { MarketplacePostsFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  totalRecords?: number;
  onSubmit?: () => void;
  marketplaceId: MarketplaceDetail['id'];
}

export const Template = ({ onSubmit, totalRecords, marketplaceId }: TemplateProps) => {
  const { t } = useTranslation();
  const { isAdvertiser, isAdminStaffAgency } = useUserRoles();

  const statusOptions: Option<MarketplaceCampaignPostStatusForSearch>[] = [
    { label: t<string>('Option.Joined'), value: MarketplaceCampaignPostStatusForSearch.JOINED },
    { label: t<string>('Option.Reviewing'), value: MarketplaceCampaignPostStatusForSearch.DRAFT },
    { label: t<string>('Option.Approved'), value: MarketplaceCampaignPostStatusForSearch.APPROVED },
    { label: t<string>('Option.Warning'), value: MarketplaceCampaignPostStatusForSearch.WARNING },
    { label: t<string>('Option.Ready to Post'), value: MarketplaceCampaignPostStatusForSearch.READY_TO_POST },
    { label: t<string>('Option.Effective'), value: MarketplaceCampaignPostStatusForSearch.EFFECTIVE },
    { label: t<string>('Option.Ineffective'), value: MarketplaceCampaignPostStatusForSearch.INEFFECTIVE }
  ];

  return (
    <Form.Fields>
      <TextSearchField<MarketplacePostsFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.EngagementPostFilter')}
      />

      <SelectorField<MarketplacePostsFilterFormKeys>
        name="status"
        onSubmit={onSubmit}
        options={statusOptions}
        className="max-w-47"
        placeholder={t<string>('Selector.Status')}
      />

      {(isAdminStaffAgency || isAdvertiser) && !!totalRecords ? (
        <DownloadMarketplacePostsButton marketplaceId={marketplaceId} />
      ) : null}
    </Form.Fields>
  );
};
